
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"15","viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.448 4.817l4.23 2.786L14 9.306v.877s-.413-.465-.929-.362c-.515-.619-.98-.31-.98-.31s-.31-.412-.98-.309c-.464-.567-1.032-.31-1.032-.31s-.412-.567-1.083-.36c-.567-.62-.619 0-.619 0s-.103.67-.67.67v.052s1.134-.052 1.134.052-1.135.051-1.135.051-.103.361-.206.361-.206-.36-.206-.36-1.135.05-1.135-.052 1.135-.052 1.135-.052v-.052c-.568 0-.671-.67-.671-.67s-.103-.62-.619 0c-.67-.207-1.083.36-1.083.36s-.568-.257-1.032.31c-.62-.154-.98.31-.98.31s-.465-.258-.98.31c-.568-.104-.929.36-.929.36v-.876l2.321-1.703 4.127-2.786"}})])
          )
        }
      }
    